import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tran-dashboard-tile',
    imports: [ReactiveFormsModule, TranslateModule, CommonModule],
    templateUrl: './dashboard-tile.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardTileComponent {
    public readonly notDefinedValue = input<string | number>('common.not-defined-abbreviation');
    public readonly icon = input<string>('');
    public readonly kpi = input<number>();
    public readonly unit = input<string>('');
    public readonly property = input<string>('');
}
